import MuiBaseModal from "../../../common/modal/MuiModal";
import AddNewGatewayForm from "../../../../forms/add-new-gateway/AddNewGatewayForm";
import { GatewaySchema } from "../../../../services/Schemas/Gateway";

interface IReceiptProps {
  openModal: boolean;
  onCloseModal: () => void;
  serverInfo?: GatewaySchema;
  handleReload?: () => void;
}

export default function PaymentCreateModal({
  openModal,
  onCloseModal,
  serverInfo,
  handleReload,
}: Readonly<IReceiptProps>) {
  return (
    <MuiBaseModal
      open={openModal}
      onClose={onCloseModal}
      title={serverInfo ? "ویرایش درگاه" : "ایجاد درگاه"}
      hasCloseIcon
    >
      <AddNewGatewayForm
        serverInfo={serverInfo}
        onClose={onCloseModal}
        handleReload={handleReload}
      />
    </MuiBaseModal>
  );
}
